import React from 'react';
import  useScrollToTop from './useScrollToTop';
import familyHomeOverview from '../img/living_room_img_1.avif'; // Replace with your actual image
import groundFloorPlan from '../img/floor_plan_6.avif'; // Replace with your actual image
import firstFloorPlan from '../img/img_floorplan_3.avif';  // Replace with your actual image
import familyLivingRoom from '../img/living_room_img_3.avif'; // Replace with your actual image
import familyHomeExterior from '../img/elevation_img_9.avif'; // Replace with your actual image
import gardenView from '../img/office_img_.avif'; // Replace with your actual image
import './ProjectStyles.css';

const CozyFamilyHomeDetails = () => {
  useScrollToTop();
  return (
    <div className='project-container'>
      <h2>Cozy Family Home with a Garden</h2>
      <img className='project-image' src={familyHomeOverview} alt="Cozy Family Home Overview" loading="lazy" />
      <div className='project-details'>
        <p>Discover a comfortable and inviting family home designed for relaxed living, featuring a delightful garden space. Situated on a 35x60 sqft plot with a built area of 2100 sqft, this home emphasizes functionality, warmth, and connection to the outdoors.</p>

        <h3>Design Concept: Comfort and Connection</h3>
        <p>The design focuses on creating a warm and welcoming atmosphere for family life. Key elements include practical layouts, ample natural light, comfortable living spaces, and a strong emphasis on the garden as an extension of the home.</p>
      </div>

      <div className='project-details'>
        <h3>Floor Plans for Family Living</h3>
        <div className='floor-plan-section'>
          <h4>Ground Floor Plan</h4>
          <img className='project-image' src={groundFloorPlan} alt="Ground Floor Plan" loading="lazy" />
          <p>The ground floor typically includes a spacious living room, a functional kitchen with a dining area, and perhaps a guest bedroom or a multi-purpose room. Easy access to the garden is a key consideration.</p>
          {/* Add more specific details about room dimensions and features here */}
        </div>

        <div className='floor-plan-section'>
          <h4>First Floor Plan</h4>
          <img className='project-image' src={firstFloorPlan} alt="First Floor Plan" loading="lazy" />
          <p>The first floor usually houses the main bedrooms, including a master bedroom with an ensuite bathroom, and additional bedrooms for children or guests. Bathrooms and storage spaces are thoughtfully integrated.</p>
          {/* Add more specific details about room dimensions and features here */}
        </div>

        <div className='built-area-breakdown'>
          <h4>Built Area Distribution</h4>
          <p>The 2100 sqft built area is efficiently distributed across the two floors to provide comfortable living spaces for the entire family.</p>
          {/* You could provide a more detailed breakdown if you have the specific numbers */}
        </div>
      </div>

      <div className='project-details'>
        <h3>Interior Comfort and Warmth</h3>
        <div className='interior-feature'>
          <h4>Inviting Living Spaces</h4>
          <img className='project-image' src={familyLivingRoom} alt="Inviting Living Room" loading="lazy" />
          <p>The interiors are designed to be cozy and inviting, with comfortable layouts and ample natural light creating a relaxed atmosphere for family time and gatherings.</p>
        </div>

        <div className='interior-feature'>
          <h4>Functional Kitchen and Dining</h4>
          <p>The kitchen is designed for everyday use and often includes a connected dining area, making it a central hub for family meals.</p>
        </div>

        {/* Add more interior features as needed, e.g., bedrooms, bathrooms */}
      </div>

      <div className='project-details'>
        <h3>Exterior and Garden Oasis</h3>
        <img className='project-image' src={familyHomeExterior} alt="Family Home Exterior" loading="lazy" />
        <div className='exterior-feature'>
          <h4>Welcoming Exterior</h4>
          <p>The exterior design emphasizes a friendly and approachable aesthetic, often incorporating elements that reflect a comfortable family home.</p>
        </div>

        <div className='exterior-feature'>
          <h4>The Garden: An Extension of Home</h4>
          <img className='project-image' src={gardenView} alt="Garden Space" loading="lazy" />
          <p>A key feature of this design is the garden, providing a valuable outdoor space for relaxation, play, and enjoying nature. It's designed to be an integral part of family life.</p>
        </div>
      </div>

      {/* Add a section for Materials and Finishes if you have specific details */}
    </div>
  );
};

export default CozyFamilyHomeDetails;